function issueKey(issue) {
    return JSON.stringify([issue.code, issue.path, issue.message]);
}
function issueCounts(issues) {
    const counts = new Map();
    for (const issue of issues) {
        const key = issueKey(issue);
        counts.set(key, (counts.get(key) ?? 0) + 1);
    }
    return counts;
}
export function strictlyReducesValidationErrors(baseline, proposed) {
    if (baseline.ok || proposed.errors.length >= baseline.errors.length)
        return false;
    const baselineCounts = issueCounts(baseline.errors);
    const proposedCounts = issueCounts(proposed.errors);
    for (const [key, count] of proposedCounts) {
        if (count > (baselineCounts.get(key) ?? 0))
            return false;
    }
    return true;
}
/**
 * Issues present in `current` that were not already present in `baseline`,
 * counted by multiplicity. This is what lets an edit report the damage it did
 * without drowning the agent in problems the document already had.
 */
export function issuesIntroduced(baseline, current) {
    const budget = issueCounts(baseline);
    const fresh = [];
    for (const issue of current) {
        const key = issueKey(issue);
        const left = budget.get(key) ?? 0;
        if (left > 0)
            budget.set(key, left - 1);
        else
            fresh.push(issue);
    }
    return fresh;
}
